/**
 * Offcanvas view for adding new sales billing
 *
 * Properties:
 *
 *      showDelayedNotification:    function, callback to display delay notification (e.g. item has been saved)
 */

import React, { useState } from "react";
import FormItem from "../../../components/FormItem";
import OffcanvasHeader from "../../../components/OffcanvasHeader";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import { moment } from "../../../../../vendor";

type Props = {
  requestPath: string;
  setAdd: any;
  saveReport: any;
};

type SaveEntity = {
  from?: string;
  to?: string;
  client_id?: number | string;
};
const AddReport: (props: Props) => React.JSX.Element = (props: Props): React.JSX.Element => {
  const { requestPath, setAdd, saveReport } = props;

  const [monthList, setMonthList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [initialized, setInitialized] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedBegin, setSelectedBegin] = useState(null);
  const [selectedEnd, setSelectedEnd] = useState(null);
  const getNameOfMonth: (m: number) => string = (m: number): string => {
    switch (m) {
      case 0:
        return t("january");
      case 1:
        return t("february");
      case 2:
        return t("march");
      case 3:
        return t("april");
      case 4:
        return t("may");
      case 5:
        return t("june");
      case 6:
        return t("july");
      case 7:
        return t("august");
      case 8:
        return t("september");
      case 9:
        return t("october");
      case 10:
        return t("november");
      case 11:
        return t("december");
      default:
        return "";
    }
  };

  const initMonthList = () => {
    let month: { name: string; value: string }[] = [
      { name: "- " + t("select month") + " -", value: "" },
    ];
    let count: number = 12;
    const currentMonth: number = moment().month();
    const currentYear: number = moment().year();

    for (let i: number = currentMonth; i >= 0; i--) {
      month.push({
        name: getNameOfMonth(i) + " " + currentYear,
        value: currentYear + "-" + (i < 9 ? "0" + (i + 1) : i + 1),
      });
      count--;
    }

    let j: number = 0;
    while (count > 0) {
      console.log("name: ", getNameOfMonth(11 - j));
      month.push({
        name: getNameOfMonth(11 - j) + " " + (currentYear - 1),
        value: currentYear - 1 + "-" + (j > 2 ? "0" + (12 - j) : 12 - j), // value matching format of moment
      });
      count--;
      j++;
    }
    // @ts-ignore
    setMonthList(month);
  };

  const onSubmitHandler1 = (e: any) => {
    // validate form ...
    let data: SaveEntity;
    data = {
      client_id: Biscuit.get("user.client_id"),
      from: moment(selectedDate).format("YYYY-MM-") + "01 00:00:00",
      to: moment(selectedDate).endOf("month").format("YYYY-MM-DD") + " 23:59:59",
    };
    let elem: HTMLElement | null = document.getElementById(e.currentTarget.name);
    elem?.classList.remove("hide");
    saveReport(data);
  };

  const onSubmitHandler2 = (e: any) => {
    // validate form ...
    let data: SaveEntity;
    if (selectedBegin !== null && selectedEnd !== null) {
      data = {
        client_id: Biscuit.get("user.client_id"),
        from: moment(selectedBegin).format("YYYY-MM-DD") + " 00:00:00",
        to: moment(selectedEnd).format("YYYY-MM-DD") + " 00:00:00",
      };
      let elem: HTMLElement | null = document.getElementById(e.currentTarget.name);
      elem?.classList.remove("hide");
      saveReport(data);
    }
  };
  const onCloseHandler = () => {
    setAdd(false);
  };

  const onMonthSelectHandle: (value: any) => void = (value: any): void => {
    value = value.target.value;
    const startOfMonth: string = moment(value).startOf("month").format("YYYY-MM-DD");
    // @ts-ignore
    setSelectedDate(startOfMonth);
    setSelectedMonth(value);
    setSelectedBegin(null);
    setSelectedEnd(null);
  };

  const onBeginChangedHandler: (date: any) => void = (date: any): void => {
    setSelectedBegin(date);
    // @ts-ignore
    setSelectedMonth(null);
  };

  const onEndChangedHandler: (date: any) => void = (date: any): void => {
    setSelectedEnd(date);
    // @ts-ignore
    setSelectedMonth(null);
  };

  const initialize = () => {
    setInitialized(true);
    initMonthList();
  };

  if (initialized === false) initialize();

  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"></div>
      <div
        className="off-canvas position-right is-transition-overlap is-open"
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        data-close-on-click="false"
        aria-hidden="false"
      >
        <OffcanvasHeader
          heading={t("create_${a}", { a: t("report") })}
          item={{}}
          noSaveButton={true}
          onCloseHandler={onCloseHandler}
          returnUrl="/reports"
        />
        <form className="off-content row" style={{ marginTop: "20px" }}>
          <div className="inb-form-group column medium-12 small-12" style={{ marginBottom: 0 }}>
            <p>{t("month selection")}</p>
          </div>
          <FormItem
            name="finances-sales-billings-date"
            label={t("month")}
            type="select"
            data={monthList}
            dataKey="value"
            selected={selectedMonth === "" ? selectedMonth : undefined}
            mediumWidth={8}
            smallWidth={6}
            onChangeHandler={onMonthSelectHandle}
            extraTopClasses=""
          />

          <FormItem
            name="finances-sales-billings-preview-first"
            type="button"
            label={t("generate")}
            link="#"
            icon=""
            beautify={true}
            round={true}
            onChangeHandler={onSubmitHandler1}
            mediumWidth={2}
            smallWidth={6}
            extraTopClasses=""
          />
          {/* <FormItem
                        name="finances-sales-billings-save1"
                        type="button"
                        label={t('save')}
                        link="#"
                        icon=""
                        beautify={true}
                        round={true}
                        onChangeHandler={onSubmitHandler1}
                        mediumWidth={2}
                        smallWidth={6}
                        extraTopClasses=""/>*/}
          <div className="inb-form-group column medium-12 small-12" style={{ marginBottom: 0 }}>
            <hr />
            <p>{t("timeperiod selection")}</p>
          </div>
          <FormItem
            name="finances-sales-billings-begin"
            type="datePicker"
            label={t("begin")}
            placeholder=""
            selected={selectedBegin}
            dateFormat="dd.MM.y"
            datePickerClass="noBorders-noBackground"
            onChangeHandler={onBeginChangedHandler}
            mediumWidth={4}
            smallWidth={12}
            extraTopClasses=""
          />
          <FormItem
            name="finances-sales-billings-end"
            type="datePicker"
            label={t("end")}
            placeholder=""
            selected={selectedEnd}
            dateFormat="dd.MM.y"
            datePickerClass="noBorders-noBackground"
            onChangeHandler={onEndChangedHandler}
            mediumWidth={4}
            smallWidth={12}
            extraTopClasses=""
          />
          <FormItem
            name="finances-sales-billings-preview"
            type="button"
            label={t("generate")}
            link="#"
            icon=""
            beautify={true}
            round={true}
            onChangeHandler={onSubmitHandler2}
            mediumWidth={2}
            smallWidth={6}
            extraTopClasses=""
          />
        </form>
      </div>
    </>
  );
};

export default AddReport;
